import React from "react";

import CustomSection from "../../custom-general/custom-section";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import { Column } from "../../../../utils/models";
import { getChunkedData } from "../../../../utils/utilities";
import { LRUTDataItem } from "../lrutDataItems";

interface Props {
    lrutItems: LRUTDataItem[];
}

const CustomLRUTSummary: React.FC<Props> = ({ lrutItems }) => {
    return ( 
        <>
            {getChunkedData(lrutItems, 25).map((chunk) => (
                <CustomSection sectionTitle="LRUT / Guided Wave Summary">
                    <div className="p-1">
                        <PDFTablePage data={chunk} columns={COLUMNS} />
                    </div>
                </CustomSection>
            ))}
        </>
     );
};

const COLUMNS: Column[] = [
    {
        path: 'shotNumber',
        label: 'GUL Shot Number'
    },
    {
        path: 'feature',
        label: 'Feature'
    },
    {
        path: 'location',
        label: 'Location (M)'
    },
    {
        path: 'ecl',
        label: 'ECL'
    },
    {
        path: 'length',
        label: 'Length (mm)'
    },
    {
        path: 'extent',
        label: 'Extent (Deg)'
    },
    {
        path: 'class',
        label: 'Class'
    },
    {
        path: 'scanDirection',
        label: 'Scan Direction'
    },
];
 
export default CustomLRUTSummary;